import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { useProgress } from "@/context/ProgressContext";
import { ALL_MODULES } from "@/data/modules";
import { Screen, ProgressBar } from "@/components/ui";

export default function ModulePage() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const { isDone, countDone } = useProgress();
  const module = ALL_MODULES.find((m) => m.id === id);

  const back = (
    <button data-testid="back-to-training-button" className="pressable" onClick={() => navigate("/training")} style={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 12, marginLeft: -4, background: "none", border: "none", cursor: "pointer" }}>
      <Icon name="chevron-left" size={20} color={colors.brand} />
      <span style={{ color: colors.brand, fontSize: 15, fontWeight: 700, fontFamily: fonts.text }}>Back to Training</span>
    </button>
  );

  if (!module) {
    return (
      <Screen>
        <div style={{ padding: "20px 24px", borderBottom: `1px solid ${colors.divider}` }}>{back}</div>
        <div style={{ padding: 40, textAlign: "center", color: colors.muted, fontFamily: fonts.text }}>This module could not be found.</div>
      </Screen>
    );
  }

  const total = module.lessons.length;
  const done = countDone(module.lessons.map((l) => l.id));
  const percent = total === 0 ? 0 : Math.round((done / total) * 100);

  return (
    <Screen>
      <div className="ritzy-fade">
        <div style={{ padding: "20px 24px 16px", borderBottom: `1px solid ${colors.divider}` }}>
          {back}
          <div style={{ color: colors.onSurface, fontSize: 26, fontFamily: fonts.display, fontWeight: 700 }}>{module.title}</div>
          <div style={{ color: colors.muted, fontSize: 13, marginTop: 4, fontFamily: fonts.text }}>{module.subtitle}</div>
        </div>
        <div style={{ padding: "20px 24px 32px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
            <div style={{ flex: 1 }}><ProgressBar percent={percent} /></div>
            <span style={{ color: colors.muted, fontSize: 13, fontWeight: 600, fontFamily: fonts.text }}>{done}/{total} done · {percent}%</span>
          </div>
          <div style={{ color: colors.muted, fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12, fontFamily: fonts.text }}>Lessons</div>
          {module.lessons.map((lesson) => {
            const complete = isDone(lesson.id);
            return (
              <button key={lesson.id} data-testid={`lesson-${lesson.id}`} className="pressable" onClick={() => navigate(`/lesson/${lesson.id}`)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 14, background: colors.surfaceSecondary, borderRadius: 16, border: `1px solid ${colors.border}`, padding: 16, marginBottom: 12, cursor: "pointer", textAlign: "left" }}>
                <div style={{ width: 26, height: 26, borderRadius: 999, border: `2px solid ${complete ? colors.success : colors.borderStrong}`, background: complete ? colors.success : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  {complete ? <Icon name="check" size={16} color={colors.onSuccess} /> : null}
                </div>
                <span style={{ flex: 1, color: complete ? colors.muted : colors.onSurface, textDecoration: complete ? "line-through" : "none", fontSize: 15, fontWeight: 600, fontFamily: fonts.text }}>{lesson.title}</span>
                <Icon name="chevron-right" size={20} color={colors.muted} />
              </button>
            );
          })}
        </div>
      </div>
    </Screen>
  );
}
